import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ops-annual-monthly-switch',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ops-annual-monthly-switch.component.html',
  styleUrls: ['./ops-annual-monthly-switch.component.scss'],
})
export class OpsAnnualMonthlySwitchComponent {
  @Input() value: 'annual' | 'monthly' = 'annual';
  @Output() valueChange = new EventEmitter<'annual' | 'monthly'>();

  isAnnual() {
    return this.value === 'annual';
  }
  isMonthly() {
    return this.value === 'monthly';
  }
  select(option: 'annual' | 'monthly') {
    if (this.value !== option) {
      this.valueChange.emit(option);
    }
  }
}
